import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TransactionHistory } from '../models/transaction-history';

@Injectable()
export class TransactionHistoryService {
	endpoint = '/api/transactionHistory';

	constructor(private readonly $http: HttpClient) {}

	getBudgets(year) {
		return this.$http.get(this.endpoint + '/getBudgets', { params: { year } });
	}

	getALBudgets(year) {
		return this.$http.get(this.endpoint + '/getALBudgets', { params: { year } });
	}

	getALBudgetsInfo(year) {
		return this.$http.get(this.endpoint + '/getALBudgetsInfo', {
			params: { year },
		});
	}

	search(filter, accountId, includeVendorName) {
		return this.$http.get<{ history: TransactionHistory[] }>(this.endpoint + '/search', {
			params: {
				journalTypeId: filter.JournalTypeId,
				accountId: accountId ? accountId : null,
				year: filter.Year ? filter.Year : null,
				from: filter.From,
				to: filter.To,
				journalcode: filter.JournalCode,
				thirteenth: filter.Thirteenth,
				refNo: filter.RefNo,
				groupByRefNo: filter.GroupByRefNo,
				includeVendorName,
			},
		});
	}

	getFiscalYears() {
		return this.$http.get(this.endpoint + '/historyFiscalYears');
	}

	getFiscalYearsByAccount(acountId) {
		return this.$http.get(this.endpoint + '/fiscalYearsByAccount', {
			params: { acountId },
		});
	}

	saveBudgets(year: number, transactions: any[], useHangfire: boolean) {
		return this.$http.post(this.endpoint + '/save-budgets', transactions, {
			params: { year, useHangfire },
		});
	}

	finalizeBudgets(finalizeModel) {
		return this.$http.post(this.endpoint + '/finalizeBudgets', finalizeModel);
	}

	saveBeginningBalance(year, transactions) {
		return this.$http.post(this.endpoint + '/beginningBalances', transactions, {
			params: { year },
		});
	}

	addJournalEntries(transactions) {
		return this.$http.post(this.endpoint + '/journalEntries', transactions);
	}

	addSavedJournalEntries(transactions) {
		return this.$http.post(this.endpoint + '/addSavedJournalEntries', transactions);
	}

	deleteSavedJournalEntries(transactionGuid) {
		return this.$http.delete(this.endpoint + '/deleteSavedJournalEntries', {
			params: { transactionGuid },
		});
	}

	getSavedJournalEntries() {
		return this.$http.get(this.endpoint + '/getSavedJournalEntries');
	}

	getSavedJournalEntriesCount() {
		return this.$http.get(this.endpoint + '/getSavedJournalEntriesCount');
	}

	getNextReferenceNo() {
		return this.$http.get(this.endpoint + '/nextReferenceNo');
	}

	// Remove when Accounts NGX is released.
	getMoreDetailedAccountHistory(transactionId) {
		return this.$http.get(this.endpoint + '/getMoreDetailedAccountHistory', {
			params: { transactionId },
		});
	}

	getTransactionHistoryDepositDetails(transactionId: number): Observable<any[]> {
		const params = new HttpParams().set('transactionId', transactionId.toString());
		return this.$http.get<any[]>(this.endpoint + '/transaction-history-deposit-details', {
			params,
		});
	}
}
